const containerStyle = {
  minHeight: "100vh",
  // background: 'linear-gradient(135deg, #eff6ff 0%, #e0e7ff 100%)',
};

const maxWidthStyle = {
  maxWidth: "1280px",
  margin: "0 auto",
};

const headerStyle = {
  textAlign: "center",
  marginBottom: "32px",
};

const mainTitleStyle = {
  fontSize: "2.25rem",
  fontWeight: "700",
  // color: '#111827',
  marginBottom: "16px",
};

const subtitleStyle = {
  color: "#6b7280",
  maxWidth: "512px",
  margin: "0 auto",
};

const progressContainerStyle = {
  marginBottom: "60px",
  padding: "0 20px",
};

const progressStepsStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  position: "relative",
  maxWidth: "900px",
  margin: "0 auto",
};

const stepItemStyle = {
  display: "flex",
  alignItems: "center",
  flex: 1,
  position: "relative",
};

const stepCircleStyle = (isActive, isCompleted) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: "56px",
  height: "56px",
  borderRadius: "50%",
  border: "3px solid",
  backgroundColor: isActive || isCompleted ? "#2563eb" : "#ffffff",
  color: isActive || isCompleted ? "#ffffff" : "#9ca3af",
  fontWeight: "700",
  fontSize: "18px",
  position: "relative",
  zIndex: 2,
  boxShadow:
    isActive || isCompleted
      ? "0 4px 12px rgba(37, 99, 235, 0.3)"
      : "0 2px 8px rgba(0, 0, 0, 0.1)",
  transition: "all 0.3s ease",
});

const stepInfoStyle = {
  position: "absolute",
  top: "70px",
  left: "36px",
  transform: "translateX(-50%)",
  textAlign: "center",
  // whiteSpace: "nowrap",
  // minWidth: "120px",
};

const stepTitleStyle = (isActive) => ({
  fontSize: "14px",
  fontWeight: "600",
  color: isActive ? "#2563eb" : "#6b7280",
  marginBottom: "4px",
});

const stepDescStyle = {
  fontSize: "12px",
  color: "#9ca3af",
  lineHeight: "1.3",
};

const progressLineStyle = {
  position: "absolute",
  top: "50%",
  left: "56px",
  right: "0",
  height: "4px",
  // backgroundColor: '#e5e7eb',
  borderRadius: "2px",
  zIndex: 1,
  transform: "translateY(-50%)",
};

const progressLineActiveStyle = (isActive) => ({
  height: "100%",
  backgroundColor: isActive ? "#2563eb" : "#e5e7eb",
  borderRadius: "2px",
  width: "100%",
  transition: "all 0.5s ease",
});

const mainContentStyle = {
  // backgroundColor: '#ffffff',
  borderRadius: "16px",
  boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
  padding: "32px",
};

const sectionTitleStyle = {
  fontSize: "1.5rem",
  fontWeight: "700",
  // color: '#111827',
  marginBottom: "24px",
  textAlign: "center",
};

const brokersGridStyle = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(400px, 1fr))",
  gap: "24px",
};

const brokerCardStyle = {
  position: "relative",

  borderRadius: "12px",
  border: "2px solid #e5e7eb",
  padding: "24px",
  cursor: "pointer",
  transition: "all 0.3s ease",
  ":hover": {
    // borderColor: "#3b82f6",
    boxShadow: "0 10px 25px -5px rgba(0, 0, 0, 0.1)",
  },
};

const brokerHeaderStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  marginBottom: "16px",
};

const brokerInfoStyle = {
  display: "flex",
  alignItems: "center",
  gap: "16px",
};

const brokerImageStyle = {
  width: "48px",
  height: "48px",
  borderRadius: "8px",
  objectFit: "cover",
};

const brokerNameStyle = {
  fontSize: "1.25rem",
  fontWeight: "700",
};

const brokerMetaStyle = {
  display: "flex",
  alignItems: "center",
  gap: "8px",
  fontSize: "0.875rem",
  color: "#6b7280",
};

const statusBadgeStyle = (status) => ({
  padding: "4px 12px",
  borderRadius: "9999px",
  fontSize: "0.75rem",
  fontWeight: "500",
  backgroundColor: status === "active" ? "#dcfce7" : "#f3f4f6",
  color: status === "active" ? "#166534" : "#374151",
});

const brokerDescStyle = {
  color: "#6b7280",
  marginBottom: "16px",
};

const featuresGridStyle = {
  display: "grid",
  gridTemplateColumns: "repeat(2, 1fr)",
  gap: "8px",
  marginBottom: "16px",
};

const featureItemStyle = {
  display: "flex",
  alignItems: "center",
  fontSize: "0.875rem",
  color: "#6b7280",
};

const apiConfigContainerStyle = {
  textAlign: "center",
  marginBottom: "32px",
};

const brokerImageLargeStyle = {
  width: "64px",
  height: "64px",
  borderRadius: "8px",
  margin: "0 auto 16px",
};

const securityNoticeStyle = {
  // backgroundColor: '#eff6ff',
  border: "1px solid #bfdbfe",
  borderRadius: "8px",
  padding: "16px",
  marginBottom: "24px",
};

const securityNoticeContentStyle = {
  display: "flex",
  alignItems: "flex-start",
  gap: "12px",
};

const securityTitleStyle = {
  fontWeight: "500",
  color: "#1e3a8a",
};

const securityTextStyle = {
  fontSize: "0.875rem",
  color: "#1e40af",
  marginTop: "4px",
};

const formContainerStyle = {
  maxWidth: "512px",
  margin: "0 auto",
};

const formGroupStyle = {
  marginBottom: "24px",
};

const labelStyle = {
  display: "block",
  fontSize: "0.875rem",
  fontWeight: "500",
  color: "#374151",
  marginBottom: "8px",
};

const inputStyle = {
  width: "100%",
  padding: "12px 16px",
  // border: '1px solid #d1d5db',
  borderRadius: "8px",
  fontSize: "16px",
  transition: "all 0.2s",
  outline: "none",
  ":focus": {
    // borderColor: "#3b82f6",
    boxShadow: "0 0 0 3px rgba(59, 130, 246, 0.1)",
  },
};

const buttonGroupStyle = {
  display: "flex",
  gap: "16px",
};

const backButtonStyle = {
  flex: 1,
  // backgroundColor: '#e5e7eb',
  color: "#374151",
  fontWeight: "500",
  padding: "12px 16px",
  borderRadius: "8px",
  border: "none",
  cursor: "pointer",
  transition: "background-color 0.2s",
  ":hover": {
    backgroundColor: "#d1d5db",
  },
};

const testConnectionStyle = {
  textAlign: "center",
};

const testContainerStyle = {
  maxWidth: "500px",
  margin: "0 auto",
};

const loadingSpinnerStyle = {
  width: "64px",
  height: "64px",
  border: "2px solid #e5e7eb",
  borderTop: "2px solid #2563eb",
  borderRadius: "50%",
  animation: "spin 1s linear infinite",
  margin: "0 auto 24px",
};

const spinKeyframes = `
    @keyframes spin {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }
  `;

const loadingTextStyle = {
  // backgroundColor: '#f9fafb',
  borderRadius: "8px",
  padding: "16px",
};

const loadingStatusStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: "8px",
  fontSize: "0.875rem",
  color: "#6b7280",
};

const pulseStyle = {
  width: "8px",
  height: "8px",
  backgroundColor: "#2563eb",
  borderRadius: "50%",
  animation: "pulse 1s ease-in-out infinite",
};

const pulseKeyframes = `
    @keyframes pulse {
      0%, 100% { opacity: 1; }
      50% { opacity: 0.5; }
    }
  `;

const successContainerStyle = {
  textAlign: "center",
};

const successIconContainerStyle = {
  width: "80px",
  height: "80px",
  // backgroundColor: '#dcfce7',
  borderRadius: "50%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  margin: "0 auto 16px",
};

const successStatusStyle = {
  // backgroundColor: '#dcfce7',
  border: "1px solid #bbf7d0",
  borderRadius: "8px",
  padding: "16px",
  marginBottom: "24px",
};

const statusRowStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  fontSize: "0.875rem",
  marginBottom: "8px",
};

const statusRowLastStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  fontSize: "0.875rem",
};

const statusLabelStyle = {
  color: "#166534",
};

const statusValueStyle = {
  fontWeight: "500",
  color: "#14532d",
};

const footerStyle = {
  textAlign: "center",
  marginTop: "32px",
  color: "#6b7280",
};

const footerTextStyle = {
  fontSize: "0.875rem",
};

const footerLinkStyle = {
  color: "#2563eb",
  textDecoration: "none",
  ":hover": {
    color: "#1d4ed8",
  },
};

// Media queries for responsive design
const responsiveStyles = `
    @media (max-width: 768px) {
      .progress-steps {
        flex-direction: column !important;
        gap: 40px !important;
      }
      
      .step-item {
        flex-direction: column !important;
        align-items: center !important;
        width: 100% !important;
      }
      
      .progress-line {
        display: none !important;
      }
      
      .step-info {
        position: static !important;
        transform: none !important;
        margin-top: 16px !important;
      }
      
      .step-circle {
        width: 48px !important;
        height: 48px !important;
        font-size: 16px !important;
      }
      
      .brokers-grid {
        grid-template-columns: 1fr !important;
        gap: 16px !important;
      }
      
      .broker-card {
        padding: 20px !important;
      }
      
      .broker-header {
        flex-direction: column !important;
        align-items: flex-start !important;
        gap: 12px !important;
      }
      
      .broker-info {
        width: 100% !important;
      }
      
      .broker-meta {
        flex-direction: column !important;
        align-items: flex-start !important;
        gap: 4px !important;
      }
      
      .features-grid {
        grid-template-columns: 1fr !important;
      }
      
      .button-group {
        flex-direction: column !important;
        gap: 12px !important;
      }
      
      .form-container {
        padding: 0 10px !important;
      }
      
      .main-content {
        padding: 24px 16px !important;
      }
      
      .main-title {
        font-size: 2rem !important;
      }
      
      .section-title {
        font-size: 1.25rem !important;
      }
    }
    
    @media (min-width: 769px) and (max-width: 1024px) {
      .progress-steps {
        max-width: 700px !important;
      }
      
      .step-circle {
        width: 52px !important;
        height: 52px !important;
      }
      
      .step-info {
        min-width: 100px !important;
      }
      
      .step-title {
        font-size: 13px !important;
      }
      
      .step-desc {
        font-size: 11px !important;
      }
    }
    
    @media (min-width: 1025px) {
      .step-info {
        min-width: 140px !important;
      }
      
      .step-desc {
        white-space: normal !important;
        max-width: 140px !important;
      }
    }
    
    ${spinKeyframes}
    ${pulseKeyframes}
  `;

const BrokerArray = [
  {
    name: "CoinDCX",
    id: 1,
    imgUrl: "https://coindcx.com/api/help/img/CoinDCX-Logo.png",
    description:
      "India's largest cryptocurrency exchange with advanced trading features",
    features: [
      "Spot Trading",
      "Futures Trading",
      "Advanced Charts",
      "API Access",
    ],
    status: "active",
    difficulty: "Easy",
    setupTime: "5 min",
  },
  {
    name: "Delta Exchange",
    id: 2,
    imgUrl:
      "https://play-lh.googleusercontent.com/RUooPad2OIFej3q8E3lUdIMfC9A_NUiXFn1Zr41BGHfgIYYDjOeJyPJ-ollns8-H_g",
    description:
      "Advanced derivatives trading platform with institutional-grade tools",
    features: [
      "Derivatives",
      "Options Trading",
      "Perpetual Futures",
      "Risk Management",
    ],
    status: "active",
    difficulty: "Medium",
    setupTime: "10 min",
  },
  {
    name: "Binance",
    id: 3,
    imgUrl:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR2CNwEe1W7zlY_r1ASpQkwS8pk-12hq20jaeN5V40&usqp=CAE&s",
    description:
      "Advanced derivatives trading platform with institutional-grade tools",
    features: [
      "Derivatives",
      "Options Trading",
      "Perpetual Futures",
      "Risk Management",
    ],
    status: "active",
    difficulty: "Medium",
    setupTime: "10 min",
  },
  {
    name: "zebpay",
    id: 4,
    imgUrl: "https://press-release-v1.s3.ap-south-1.amazonaws.com/order/14935/1729513490712_content_img.jpeg",
    description:
      "India's first cryptocurrency exchange with a focus on security and compliance",
    features: ["Spot Trading", "Staking", "Recurring Buys", "API Access"],
    status: "active",
    difficulty: "Easy",
    setupTime: "5 min",
  },
  {
    name: "CoinSwitch",
    id: 5,
    imgUrl: "https://play-lh.googleusercontent.com/L0JfyWa6L3i_aYfeBtYI6oa-9wnuBznfIvWgp2asAL-O7VJDk4Kjqm8ShIa_c07LM8jqh_-R3-icMr-cvcUO",
    description:
      "A leading cryptocurrency exchange aggregator offering a wide range of coins and tokens",
    features: ["Multi-Exchange Access", "Wide Coin Selection", "No Account Needed", "API Access"],
    status: "active",
    difficulty: "Easy",
    setupTime: "5 min",
  },
  {
    name: "Pi42",
    id: 6,
    imgUrl: "data:image/png;base64,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",
    description: "A leading cryptocurrency exchange aggregator offering a wide range of coins and tokens",
    features: ["Multi-Exchange Access", "Wide Coin Selection", "No Account Needed", "API Access"],
    status: "active",
    difficulty: "Easy",
    setupTime: "5 min",
  }
];

const brokerFields = {
  1: [
    {
      label: "API Key",
      type: "text",
      name: "api_key",
      placeholder: "Enter your API key",
    },
    {
      label: "API Secret *",
      type: "password",
      name: "api_secret",
      placeholder: "Enter your API secret",
    },
  ],
  2: [
    {
      label: "API Key",
      type: "text",
      name: "api_key",
      placeholder: "Enter your API key",
    },
    {
      label: "API Secret *",
      type: "password",
      name: "api_secret",
      placeholder: "Enter your API secret",
    },
  ],
  3: [
    {
      label: "API Key",
      type: "text",
      name: "api_key",
      placeholder: "Enter your API key",
    },
    {
      label: "API Secret *",
      type: "password",
      name: "api_secret",
      placeholder: "Enter your API secret",
    },
  ],
  4: [
    {
      label: "API Key",
      type: "text",
      name: "api_key",
      placeholder: "Enter your API key",
    },
    {
      label: "API Secret *",
      type: "password",
      name: "api_secret",
      placeholder: "Enter your API secret",
    },
  ],
  5: [
    {
      label: "API Key",
      type: "text",
      name: "api_key",
      placeholder: "Enter your API key",
    },
    {
      label: "API Secret *",
      type: "password",
      name: "api_secret",
      placeholder: "Enter your API secret",
    },
  ],
  6: [
    {
      label: "API Key",
      type: "text",
      name: "api_key",
      placeholder: "Enter your API key",
    },
    {
      label: "API Secret *",
      type: "password",
      name: "api_secret",
      placeholder: "Enter your API secret",
    },
  ],
};

const connectionSteps = [
  {
    step: 1,
    title: "Choose Broker",
    description: "Select your preferred broker from available options",
  },
  {
    step: 2,
    title: "API Configuration",
    description: "Enter your API credentials and configure settings",
  },
  {
    step: 3,
    title: "Test Connection",
    description: "Verify connection and test API functionality",
  },
  {
    step: 4,
    title: "Complete Setup",
    description: "Finalize configuration and start trading",
  },
];

export default {
  BrokerArray,
  brokerFields,
  connectionSteps,

  containerStyle,
  headerStyle,
  subtitleStyle,
  progressContainerStyle,
  progressStepsStyle,
  stepItemStyle,
  stepCircleStyle,
  stepInfoStyle,
  stepTitleStyle,
  stepDescStyle,
  progressLineStyle,
  progressLineActiveStyle,

  brokersGridStyle,
  brokerCardStyle,
  brokerHeaderStyle,
  brokerInfoStyle,
  brokerMetaStyle,
  featuresGridStyle,
  buttonGroupStyle,
  formContainerStyle,
  mainContentStyle,
  mainTitleStyle,
  sectionTitleStyle,
  brokerImageStyle,
  brokerNameStyle,
  brokerDescStyle,
  brokerImageLargeStyle,
  securityNoticeStyle,
  securityNoticeContentStyle,
  securityTitleStyle,
  securityTextStyle,
  formGroupStyle,
  labelStyle,
  inputStyle,
  apiConfigContainerStyle,
  backButtonStyle,
  testConnectionStyle,
  testContainerStyle,
  loadingSpinnerStyle,
  loadingTextStyle,
  loadingStatusStyle,
  pulseStyle,
  successContainerStyle,
  successIconContainerStyle,
  successStatusStyle,
  statusRowStyle,
  statusRowLastStyle,
  statusLabelStyle,
  statusValueStyle,
  responsiveStyles,
  maxWidthStyle,
  footerStyle,
  footerTextStyle,
  footerLinkStyle,
  statusBadgeStyle,
  featureItemStyle,
};
